








































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element';

import { mapGetters } from 'vuex';

import { AlignEnum } from '../../enums';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { CRUD_CONSTS } from '../../store/crud/crud.consts';

import Badge from '../badge.component.vue';
import CrudList from '../crud/crud-list.component.vue';
import DataTable from '../crud/data-table.component.vue';
import NoDataFound from '../crud/no-data-found.component.vue';
import { UiModal } from '../keen-ui';
import EditProductsForm from './edit-products-form.component.vue';

export default {
  name: 'ranked-products',
  components: {
    Badge,
    CrudList,
    DataTable,
    NoDataFound,
    EditProductsForm,
    UiModal
  },
  computed: {
    ...mapGetters(CRUD_CONSTS.moduleName, {
      state: CRUD_CONSTS.getters.state
    })
  },
  props: {
    products: Array,
    title: String
  },
  data: function () {
    const messages = this.$epb.messages.tools.productsRanking;
    return {
      dataType: ActionTypeEnum.PRODUCTS_RANKING,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.productsRanking.update),
      columns: [
        {
          id: 'order',
          width: '3rem',
          align: AlignEnum.END
        }, {
          id: 'name',
          text: messages.fields.name.label
        }, {
          id: 'fieldValue',
          text: messages.fields.fieldValue.label,
          width: '10rem'
        }, {
          id: 'filters',
          text: messages.fields.filters.label,
          width: '7rem'
        }, {
          id: 'schedule',
          text: messages.fields.schedule.label,
          width: '7rem'
        }, {
          id: 'imageUrl',
          text: messages.fields.imageUrl.label,
          width: '8rem',
          align: AlignEnum.CENTER
        }
      ],
      selection: [],
      productToPreview: undefined,
      editOpened: false,
      messages: messages
    };
  },
  methods: {
    onProductImageClick: function (product: RankingElement): void {
      this.productToPreview = product;
      this.$refs.imageUrlPreviewModal.open();
    },
    getProductIndex: function (product: RankingElement): number {
      return this.products.findIndex(productItem => productItem.fieldValue === product.fieldValue);
    },
    getProductFiltersLength: function (product): number {
      return Object.keys(product.filters).length;
    },
    onSelectionChange: function (selection: any[]): void {
      this.selection = selection;
    },
    deleteProductSelection: function (): void {
      this.$emit('deleteRankedProducts', this.selection);
    }
  },
  watch: {
    'editOpened': function (): void {
      const editModal = this.$refs.editProductsModal;
      this.editOpened ? editModal.open() : editModal.close();
    },
    'selection': {
      handler: function (): void {
        this.$emit('applyUpdatesOnProducts', this.selection);
      }
    }
  }
};
